import { Injectable } from "@angular/core";
import { IUserBrandingRepository } from "../../../domain/user-branding-repository";
import { BackofficeUserBrandingSettings } from "../../../domain/user-branding";
import { HttpService } from "../../http/http";
import { UserBrandingSetting } from "app/js/src/domain/user-branding-setting";

@Injectable()
export class UserBrandingRepository implements IUserBrandingRepository {
  constructor(private httpService: HttpService) {
  }

  delete(domainNameAsUid: string): Promise<boolean> {
        return new Promise<boolean>(resolve => {
          try {
            this.httpService.delete(`UserBranding?domainName=${domainNameAsUid}`).then(() => {
              resolve(true);
            });
          }catch (e) {
            console.log(`UserBrandingRepository->delete->${domainNameAsUid}->error`, e);
            resolve(false);
          }
        });
    }
    upsert(userBrandingSetting: UserBrandingSetting): Promise<boolean> {
      return new Promise<boolean>(resolve => {
        try {
          this.httpService.post(`UserBranding`, {
            DomainName: userBrandingSetting.domainNameAsUid,
            UserBrandingSettings: JSON.stringify(userBrandingSetting)
          }).then(() => {
            resolve(true);
          });
        }catch (e) {
          console.log(`UserBrandingRepository->upsert-->error`, userBrandingSetting, e);
          resolve(false);
        }
      });
    }
    getAll(): Promise<UserBrandingSetting[]> {
        return this.httpService.get(`UserBranding/GetSettings`)
          .then((response: any[]) => {
            return response.map(r => UserBrandingSetting.fromRawResponse(r));
          });
    }

  getBackofficeUserBrandingSettingForCurrentDomain(domainName: string): Promise<BackofficeUserBrandingSettings> {
    return new Promise<BackofficeUserBrandingSettings>((resolve) => {
      this.httpService
        .get("userbranding/get?domainName=" + domainName)
        .then((result) => {
          const userBrandingSettings = JSON.parse(result);
          const backofficeUserBrandingSettings =
            userBrandingSettings.backoffice;
          console.log(
            "getUserBrandingSettings",
            backofficeUserBrandingSettings,
          );
          resolve(
            BackofficeUserBrandingSettings.FromRawObject(backofficeUserBrandingSettings),
          );
        });
    });
  }
}
